import * as utils from 'utils';
import * as handlers from './map.handlers';

export const mapLayers = {
  buildings: {
    name: '3D Buildings',
    config: [
      {
        name: '3D Buildings',
        id: '3d-buildings',
        source: 'mapbox-streets',
        'source-layer': 'building',
        filter: ['==', 'extrude', 'true'],
        type: 'fill-extrusion',
        minzoom: 15,
        paint: {
          'fill-extrusion-color': '#aaa',
          'fill-extrusion-height': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'height']],
          'fill-extrusion-base': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'min_height']],
          'fill-extrusion-opacity': 0.6,
        },
        visibility: 'none',
      },
    ],
    visibility: utils.map.visibility.none,
  },
  contours: {
    name: 'Contours',
    config: [
      {
        name: 'Contours',
        id: 'contour',
        layout: {
          visibility: 'visible',
        },
        type: 'line',
        source: 'mapbox-terrain',
        paint: {},
        'source-layer': 'contour',
        visibility: 'none',
      },
      {
        name: 'Contour Labels',
        id: 'contour-label',
        layout: {
          'symbol-placement': 'line',
          'text-field': ['concat', ['to-string', ['get', 'ele']], 'm (', ['to-string', ['*', ['get', 'ele'], 3.3]], 'ft)'],
        },
        type: 'symbol',
        source: 'mapbox-terrain',
        paint: {
          'text-halo-color': 'hsl(0, 0%, 100%)',
          'text-halo-width': 1,
        },
        'source-layer': 'contour',
        visibility: 'none',
      },
    ],
    visibility: utils.map.visibility.none,
  },
  nfhl: {
    name: 'National Flood Hazard Layer',
    config: [
      {
        name: 'National Flood Hazard Layer',
        id: 'nfhl',
        type: 'raster',
        paint: {
          'raster-opacity': 0.5,
        },
        source: {
          type: 'raster',
          tiles: [
            'https://hazards.fema.gov/gis/nfhl/rest/services/public/NFHL/MapServer/export?bbox={bbox-epsg-3857}&bboxSR=3857&layers=&layerDefs=&size=256%2c256&imageSR=3857&format=png&transparent=true&dpi=&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=image',
          ],
        },
        visibility: 'none',
      },
    ],
    visibility: utils.map.visibility.none,
  },
  weatherRadar: {
    name: 'Weather Radar Imagery',
    config: [
      {
        name: 'Weather Radar Imagery',
        id: 'noaa-wri',
        type: 'raster',
        paint: {
          'raster-opacity': 0.5,
        },
        source: {
          type: 'raster',
          tiles: [
            'https://new.nowcoast.noaa.gov/arcgis/rest/services/nowcoast/radar_meteo_imagery_nexrad_time/MapServer/export?bbox={bbox-epsg-3857}&bboxSR=EPSG%3A3857&layers=&layerDefs=&size=256%2c256&imageSR=&format=png&transparent=true&dpi=&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=image',
          ],
        },
        visibility: 'none',
      },
    ],
    visibility: utils.map.visibility.none,
  },
  liveHurricanes: {
    name: 'Live Hurricanes',
    config: [
      {
        name: 'New Noaa',
        id: 'noaa-track-intensity',
        type: 'raster',
        paint: {
          'raster-opacity': 0.5,
        },
        source: {
          type: 'raster',
          tiles: [
            'https://new.nowcoast.noaa.gov/arcgis/rest/services/nowcoast/wwa_meteocean_tropicalcyclones_trackintensityfcsts_time/MapServer/export?bbox={bbox-epsg-3857}&bboxSR=EPSG%3A3857&layers=&layerDefs=&size=256%2c256&imageSR=&format=png&transparent=true&dpi=&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=image',
          ],
        },
        visibility: 'none',
      },
    ],
    visibility: utils.map.visibility.none,
  },
  coastalFlood: {
    name: 'Coastal Flood Exposure (Category 5)',
    config: [
      {
        name: 'Coastal Flood Exposure',
        id: 'costal-flood',
        type: 'raster',
        paint: {
          'raster-opacity': 0.5,
        },
        source: {
          type: 'raster',
          tiles: [
            'https://tiles.arcgis.com/tiles/C8EMgrsFcRFL6LrL/arcgis/rest/services/Storm_Surge_HazardMaps_Category5_v3/MapServer/tile/{z}/{y}/{x}?cacheKey=850d1267fde37737',
          ],
        },
        visibility: 'none',
      },
    ],
    visibility: utils.map.visibility.none,
  },
  liveWildFires: {
    name: 'Live Wildfires',
    id: 'liveWildFires',
    config: [
      {
        name: 'Live Wildfires',
        id: 'liveWildFires',
        type: 'circle',
        source: {
          type: 'geojson',
          data: 'https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services/WFIGS_Incident_Locations_Current/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson',
        },
        paint: {
          'circle-radius': 5,
          'circle-color': 'orange',
          'circle-stroke-color': 'red',
          'circle-stroke-width': 2,
          'circle-opacity': 0.5,
        },
        visibility: 'none',
      },
    ],
    events: [
      {
        eventName: 'mouseenter',
        handler: handlers.onWildFireHoverPopup,
      },
      {
        eventName: 'mouseleave',
        handler: handlers.onExit,
      },
    ],
    visibility: utils.map.visibility.none,
  },
  historicWildFires: {
    name: 'Historic Wildfires',
    id: 'historicWildFires',
    config: [
      {
        name: 'Historic Wildfires',
        id: 'historicWildFires',
        type: 'circle',
        source: {
          type: 'geojson',
          data: 'https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services/WFIGS_Incident_Locations/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson',
        },
        paint: {
          'circle-radius': 5,
          'circle-color': 'red',
          'circle-stroke-color': 'red',
          'circle-stroke-width': 4,
          'circle-opacity': 0.5,
        },
        visibility: 'none',
      },
    ],
    events: [
      {
        eventName: 'mouseenter',
        handler: handlers.onWildFireHoverPopup,
      },
      {
        eventName: 'mouseleave',
        handler: handlers.onExit,
      },
    ],
    visibility: utils.map.visibility.none,
  },
  massShootings2002: {
    name: 'Mass Shootings 2022',
    id: 'mass-shootings-2022',
    config: [
      {
        name: 'Mass Shootings 2022',
        id: 'mass-shootings-2022',
        type: 'circle',
        source: {
          type: 'geojson',
          data: 'https://edgeassets.blob.core.windows.net/geojson/shootings-2022.json',
        },
        paint: {
          'circle-radius': 4,
          'circle-color': '#e93d4c',
          'circle-stroke-color': '#e93d4c',
          'circle-stroke-width': 2,
          'circle-opacity': 0.5,
        },
        filter: ['==', '$type', 'Point'],
        visibility: 'none',
      },
    ],
    events: [
      {
        eventName: 'mouseenter',
        handler: handlers.onShootingsHoverPopup,
      },
      {
        eventName: 'mouseleave',
        handler: handlers.onExit,
      },
    ],
    visibility: utils.map.visibility.none,
  },
  allShootings: {
    name: 'All Shootings (2014 - 2019)',
    id: 'all-shootings',
    config: [
      {
        name: 'All Shootings',
        id: 'all-shootings',
        type: 'circle',
        source: {
          type: 'geojson',
          data: 'https://pf-public-json-data.s3.eu-west-2.amazonaws.com/terrorism/allShootings.json',
        },
        paint: {
          'circle-radius': 4,
          'circle-color': '#32CD32',
        },
        filter: ['==', '$type', 'Point'],
        visibility: 'none',
      },
    ],
    events: [
      {
        eventName: 'mouseenter',
        handler: handlers.onShootingsHoverPopup,
      },
      {
        eventName: 'mouseleave',
        handler: handlers.onExit,
      },
    ],
    visibility: utils.map.visibility.none,
  },
  massShootings: {
    name: 'Mass Shootings (2014 - 2019)',
    id: 'mass-shootings',
    config: [
      {
        name: 'Mass Shootings',
        id: 'mass-shootings',
        type: 'circle',
        source: {
          type: 'geojson',
          data: 'https://pf-public-json-data.s3.eu-west-2.amazonaws.com/terrorism/massShootings.json',
        },
        paint: {
          'circle-radius': 4,
          'circle-color': '#B42222',
        },
        filter: ['==', '$type', 'Point'],
        visibility: 'none',
      },
    ],
    events: [
      {
        eventName: 'mouseenter',
        handler: handlers.onShootingsHoverPopup,
      },
      {
        eventName: 'mouseleave',
        handler: handlers.onExit,
      },
    ],
    visibility: utils.map.visibility.none,
  },
};
